import { BcModel } from './../../models/societe-linked/bc/bc.model';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { SimpleQueryResponse } from '../../dtos/simpleQueryResponse';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { FilterBcDTO } from '../../dtos/filterBcDTO';
import { BcValidationModel } from '../../dtos/bcValidationModel';
import { DashboardModel } from '../../dtos/dashboard.model';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { HostnameService } from '../basic/hostname.service';
import { EmailFournisseurDTO } from '../../dtos/EmailFournisseurDTO';
import { CycleBcModel } from '../../models/societe-linked/bc/cycle-bc.model';

@Injectable()
export class BcService extends SocieteLinkedService<BcModel> {
    observer = new BehaviorSubject<BcModel>(null);
    public bcSubscriber = this.observer.asObservable();

    constructor(protected http: HttpClient,
                protected toastr: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastr, APICONSTANTS.ROUTEBC, hostnameService);
    }
    getBcsHasBp(value: string): Observable<BcModel[]> {
        return this.http.get<BcModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetBcsHasBp/' + value)
          .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
    }

    getFiltredBc(fitredto: FilterBcDTO): Observable<SimpleQueryResponse<BcModel>> {
        return super.getAllFromObjet('GetfiltredData/', fitredto).pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
    }

    saveBc(t: BcModel, action: string): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'PostBc?action=' + action, t)
            .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
    }

    toBrouillon(t: BcModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'toBrouillon', t)
            .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement du brouillon')));
    }
    toAValider(t: BcModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'toAValider', t)
            .pipe(catchError(err => this.requestCatchError(err, 'L\'envoie en validation')));
    }
    getAuthorisation(codeCa1: string, idSociete: number): Observable<number[]> {
        // tslint:disable-next-line: max-line-length
        return this.http.get<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'getAuthorisation?codeCa1=' + codeCa1 + '&idSociete=' + idSociete)
            .pipe(catchError(err => this.requestCatchError(err, 'Le chargement des droits')));
    }
    
    validateBc(bcForValidation: BcValidationModel): Observable<BcModel> {
        return this.http.put<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'validate', bcForValidation)
            .pipe(catchError(err => this.requestCatchError(err, 'La validation')));
    }

    refusBc(bcForRefus: BcValidationModel): Observable<BcModel> {
        return this.http.put<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'Refus', bcForRefus)
            .pipe(catchError(err => this.requestCatchError(err, 'Le refus')));
    }

    getDashboardMyBcs(): Observable<DashboardModel> {
        return this.http.get<DashboardModel>(APICONSTANTS.URLAPI.value + this.route + 'GetDashboardMyBcs')
            .pipe(catchError(err => this.requestCatchError(err, 'L\'affichage')));
    }
    getDashboardAllBcs(): Observable<DashboardModel> {
        return this.http.get<DashboardModel>(APICONSTANTS.URLAPI.value + this.route + 'GetDashboardAllBcs')
            .pipe(catchError(err => this.requestCatchError(err, 'L\'affichage')));
    }
    getDashboardValidationBcs(): Observable<DashboardModel> {
        return this.http.get<DashboardModel>(APICONSTANTS.URLAPI.value + this.route + 'GetDashboardValidationBcs')
            .pipe(catchError(err => this.requestCatchError(err, 'L\'affichage')));
    }

    duplicate(t: BcModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'duplication', t)
            .pipe(catchError(err => this.requestCatchError(err, 'Duplication')));
    }
    
    regularisationBc(t: BcModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'regularisationBc', t)
            .pipe(catchError(err => this.requestCatchError(err, 'Complétion du BC')));
    }

    refaireBc(t: BcModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'refaireBc', t)
            .pipe(catchError(err => this.requestCatchError(err, 'Refaire le BC')));
    }
    
    cancel(t: BcModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'annulation', t)
            .pipe(catchError(err => this.requestCatchError(err, 'L\'annulation')));
    }

    sendImportedBc(fileForm: File): Observable<HttpEvent<string>> {
        const formData = new FormData();
        formData.append('file', fileForm);

        return this.http.post<HttpEvent<string>>(APICONSTANTS.URLAPI.value + this.route + 'importBcFromDocsV2', formData)
            .pipe(catchError(err => {
                const d = this.requestCatchError(err, 'Import BC');
                return d;
            }));
    }

    updateBc(t: BcValidationModel): Observable<BcModel> {
        // tslint:disable-next-line: max-line-length
        return this.http.put<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'updateBc',t).pipe(catchError( err => this.requestCatchError(err, 'Update')));
    }

    updateBCEnv(t: BcValidationModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'updateBCEnv', t)
            .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement des lignes et livraisons de BC enveloppe')));
    }

    clotureBCE(t: BcValidationModel): Observable<BcModel> {
        return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'cloturerBCE', t)
            .pipe(catchError(err => this.requestCatchError(err, 'La cloture du BC enveloppe')));
    }

    debloquerBc(t: BcValidationModel): Observable<BcModel> {
        // tslint:disable-next-line: max-line-length
        return this.http.put<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'debloquerBc',t).pipe(catchError( err => this.requestCatchError(err, 'Update')));
    }

    exportBcs(filtre: FilterBcDTO) {
        // tslint:disable-next-line: max-line-length
        return this.http.post(APICONSTANTS.URLAPI.value + this.route + 'exportBcs', filtre, {responseType: 'text'}).pipe(catchError(err => this.requestCatchError(err, 'Export')));
    }

    sendEmailToFournisseur(emailFournisseurModel: FormData) : Observable<string>{
        return this.http.post<string>(APICONSTANTS.URLAPI.value + this.route + 'sendEmailToFournisseur', emailFournisseurModel)
           .pipe(catchError(err => this.requestCatchError(err, 'Erreur dans l\'envoi de mail pour le fournisseur')));
    }
}
